export default {
  components: {},
  props: {
    screen: {
      type: Object,
      default: () => {
      }
    },
  },
  data() {
    return {
      msg: 'what',
      username:'',
      url: {
        save: SZH.assets.api + '/Login/OutLogin'
      },
      fullscreenLoading: false,
      menus: [
        {
          name: '商城首页',
          url: '/',
          active: false,
        },
        {
          name: '交易大厅',
          url: '/Menu/Products',
          active: true,
        },
        {
          name: '招标大厅',
          url: '/Menu/AuctionHallList',
          active: true,
        },
        {
          name: '竞采大厅',
          url: '/Menu/BidBuyList',
          active: true,
        },
        {
          name: '询价大厅',
          url: '/Menu/EnquiryList',
          active: true,
        },
        {
          name: '支持与服务',
          // url:'/Menu/SupportAndService',
          url: '/HomeSupport', //2021/11/8 未出图 suilei要求跳转首页 支持与服务
          active: false,
        },
        {
          name: '联系我们',
          // url:'/Menu/ContactUs',
          url: '/HomeAbout',//2021/11/8 未出图 suilei要求跳转首页 联系我们
          active: false,
        },
      ]
    }
  },
  computed: {},
  mounted() {
    this.username = localStorage.getItem('ms_username');
  },
  methods: {
    toRegest() {

    },
    loginOut() {
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.save, self.form)
        .then(result => {
          if (result.state == true) { //
            self.$message.success('退出成功!');
            localStorage.removeItem('ms_isLogin');
            localStorage.removeItem('ms_username');
            self.$router.push({
              path: '/LoginTH'
            })
          } else {
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          // 请求失败
          self.$message.error('退出失败，请检查您的网络是否可用。');
          self.fullscreenLoading = false;
        });
    },
    turnTo(url) {
      this.$router.push({
        path: url,
      })
    },
  },
  watch: {}
}




// WEBPACK FOOTER //
// ./src/components/HeaderB/HeaderB.js